import { EventEmitter, Injectable } from '@angular/core';
import { UiServices } from './ui-services';

@Injectable({
  providedIn: 'root',
})
export class GiftCardService {
  public giftCard: any[] = undefined;
  public client = undefined;

  public giftCardAndCouponsAmount = 0;
  public giftCardAndCouponsAmount$ = new EventEmitter<number>();

  constructor(private uiSv: UiServices) {}

  async setTransferType() {
    const { role } = await this.uiSv.presentAlert(
      '',
      true,
      'OTRO_USUARIO',
      false,
      'PARA_MI',
      'A_QUIEN_DESEAS_RECARGAR'
    );
    return role;
  }

  setNewAmount(amount: number) {
    this.giftCardAndCouponsAmount = amount;
  }

  emitCheckboxesId(id: number) {
    this.giftCardAndCouponsAmount$.emit(id);
  }
}
